import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from '../app.service';
import { LoaderService } from '../loader/loader.service';

@Component({
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css'],
  providers: [AppService, LoaderService]
})
export class QuestionsComponent implements OnInit {
  error: String;

  constructor(
    private appService: AppService,
    private loaderService: LoaderService
  ) {}

 	ngOnInit() {}

  onSubmit(ff: NgForm) {
    this.error = '';
    if(!ff.value.messagesNumber){
      alert('Vous ne pouvez pas laisser de champ(s) vide(s)');
    } else {
      this.loaderService.show();
      this.appService.sendQuestions({
        messagesNumber: ff.value.messagesNumber
      })
       .subscribe((res) => {
        console.log("res:", res);
        this.loaderService.hide();
      }, (err) => {
        this.loaderService.hide();
        this.error = err;
      });
    }
  }
}




// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/questions/questions.component.ts